export default "__VITE_ASSET__BPxNr10j__"